import './assets/styles/refundModal.scss'
import {installOperationFeedback} from './utils/operationFeedback'
import './assets/styles/operationFeedback.scss'
import {installNavigationHoverHints, dismissNavigationHoverHints} from './utils/navigationHoverHints'
import {Modal} from 'ant-design-vue'
import {installPopupFeedback} from './utils/popupFeedback'
import {installEnterActions} from './utils/enterActions'
import {formatOrderMoney,formatOrderMoneyCell} from './utils/orderMoney'
import AdminImage from './components/AdminImage.vue'
import ProductImage from './components/ProductImage.vue'
import AdminImagePreview from './components/AdminImagePreview.vue'
import {safeAddressText,isAddressField} from './utils/overflowDetail'
import {installReadonlyFieldCopies} from './utils/readonlyFieldCopies'
import {installFilterSelectWidth} from './utils/filterSelectWidth'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import '@/assets/styles/index.scss'
import installIcons from '@/assets/icons/index'
import i18n from '@/i18n/index'
// 2026-10-18：只在展示层使用译文，所有页面共享语言状态与空间适配。
import { installLocalizedFeedback } from '@/i18n/feedback'
import { translateUi, translateUiFields, translateUiField, formatUi } from '@/i18n/display'
import '@/i18n/layout.scss'
import '@/assets/styles/admin-skin.scss'
import './router/permission'
// import { generateNewStyle } from '@/utils/theme'
// import API from 'fghis-ui'
// import 'fghis-ui/dist/css/index.css'
import Loading from '@/components/cLoading'

import CommonUi from '@/components/index'
const app = createApp(App)
installNavigationHoverHints(app)
router.beforeEach(()=>{dismissNavigationHoverHints()})
installEnterActions(app)
app.config.globalProperties.$orderMoney=formatOrderMoney
app.config.globalProperties.$orderMoneyCell=formatOrderMoneyCell
// 只处理渲染值，不更改订单/收货数据与提交参数；权限变化由Vuex触发重绘。
app.config.globalProperties.$safeAddress=(value:unknown)=>safeAddressText(value,Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber))
app.config.globalProperties.$safeField=(value:unknown,field:unknown)=>isAddressField(field)?safeAddressText(value,Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber)):/^\/orders(?:\/|$)/.test(router.currentRoute.value.path)?formatOrderMoneyCell(value,field):value
installFilterSelectWidth(app)
installReadonlyFieldCopies(app)
app.config.globalProperties.$ui = translateUi
app.config.globalProperties.$uiFields = translateUiFields
app.config.globalProperties.$uiField = translateUiField
app.config.globalProperties.$uiFormat = formatUi
installLocalizedFeedback()
installPopupFeedback(Modal,()=>JSON.stringify([router.currentRoute.value.fullPath,store.getters.token,store.getters.orgId,store.getters.userInfo?.orgId]))
installOperationFeedback(app,()=>JSON.stringify([router.currentRoute.value.fullPath,store.getters.token,store.getters.orgId,store.getters.userInfo?.id,store.getters.userInfo?.orgId]))
// console.log(CommonUi)
installIcons(app)
// API.install(app)
app.component('ProductImage',ProductImage).component('AdminImage',AdminImage).component('AdminImagePreview',AdminImagePreview)
app.use(store).use(router).use(Antd).use(Loading).use(CommonUi).use(i18n).mount('#app')
// generateNewStyle(store.getters.theme)
